module.exports = __webpack_public_path__ + "static/media/team-member27.10cedc1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/aboutUs/images/team-member27.jpg
// module id = 140
// module chunks = 0